import React, { useState } from "react";
import Footer from "../Footer";
import Sidebar from "../sidebar";
import Topnav from "../TopNav";
import { API_URL, token } from "../config";
import Swal from "sweetalert2";

const ChangePassword = () => {
    const storedUser = localStorage.getItem('author');
    const author = JSON.parse(storedUser);

    const [formData, setFormData] = useState({
        email: author?.email || '',
        oldPassword: '',
        newPassword: '',
        ConfirmPassword: ''
    });
    const [show, setShow] = useState(false);

    const toggleSidebar = () => {
        setShow(prevShow => !prevShow);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.newPassword !== formData.ConfirmPassword) {
            Swal.fire({ text: "Passwords do not match!", icon: "error" });
            return;
        }

        try {
            const response = await fetch(`${API_URL}/authors/change-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token()}`
                },
                body: JSON.stringify({
                    oldPassword: formData.oldPassword,
                    newPassword: formData.newPassword
                }),
            });

            const data = await response.json();

            if (response.ok) {
                Swal.fire({ text: data.message || "Password changed successfully!", icon: "success" });
                setFormData({ ...formData, oldPassword: '', newPassword: '', ConfirmPassword: '' });
            } else {
                Swal.fire({ text: data.error || "Password change failed!", icon: "error" });
            }
        } catch (error) {
            console.error("Error resetting password:", error);
            Swal.fire({ text: "An error occurred.", icon: "error" });
        }
    };

    return (
        <html lang="en">
            <body>
                <div className="wrapper">
                    <Sidebar show={show} />
                    <div className="main-panel">
                        <Topnav toggleSidebar={toggleSidebar} />
                        <div className="container">
                            <div className="page-inner">
                                <form onSubmit={handleSubmit} className="page-inner">
                                    <div className="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
                                        <h3 className="fw-bold mb-3">Change Password</h3>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <label htmlFor="oldPassword">Old Password</label>
                                            <input
                                                type="password"
                                                name="oldPassword"
                                                id="oldPassword"
                                                className="form-control"
                                                style={{ border: '0.5px solid #1e3a8a' }}
                                                value={formData.oldPassword}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-lg-6">
                                            <label htmlFor="newPassword">New Password</label>
                                            <input
                                                type="password"
                                                name="newPassword"
                                                id="newPassword"
                                                className="form-control"
                                                style={{ border: '0.5px solid #1e3a8a' }}
                                                value={formData.newPassword}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <br />
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <label htmlFor="ConfirmPassword">Confirm Password</label>
                                            <input
                                                type="password"
                                                name="ConfirmPassword"
                                                id="ConfirmPassword"
                                                className="form-control"
                                                style={{ border: '0.5px solid #1e3a8a' }}
                                                value={formData.ConfirmPassword}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-lg-6">
                                            <label>&nbsp;</label>
                                            <button type="submit" className="btn form-control" style={{ backgroundColor: '#1e3a8a', color: '#ffffff' }}>
                                                Update
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <footer className="footer">
                            <Footer />
                        </footer>
                    </div>
                </div>
            </body>
        </html>
    );
};

export default ChangePassword;